<mat-form-field class="bold-required-field">
  <mat-label>
    {{ fieldLabel }}
  </mat-label>
  <input
    matInput
    [formControl]="searchAddressControl"
    [errorStateMatcher]="errorStateMatcher"
    [matAutocomplete]="addressAuto"
    [attr.test-id]="testId"
    [readonly]="disabled"
    (blur)="onBlur()"
  />
  <mat-autocomplete #addressAuto="matAutocomplete" (optionSelected)="onOptionSelected($event)">
    <mat-option
      *ngFor="let address of addresses"
      [value]="address"
      [matTooltip]="address.fullAddress"
      class="address-option"
    >
      <div class="address-option__text">{{ address.fullAddress }}</div>
    </mat-option>

    <div *ngIf="isLoadMoreEnabled" class="load-more">
      <span class="link" (click)="onLoadMore()">
        <ui-svg-icon [name]="iconNames.Refresh" class="tw-align-middle"></ui-svg-icon>
        {{ 'monitoring.uli.create.uliInfo.loadMoreAddress' | translate : { amount: loadMoreAmount } }}
      </span>
    </div>
  </mat-autocomplete>

  <mat-hint class="info-text">{{ 'monitoring.uli.create.uliInfo.autocompleteAddressInfo' | translate }}</mat-hint>
  <mat-error>
    <ng-content></ng-content>
  </mat-error>
</mat-form-field>
